var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 74,
    viewBox: "0 0 73 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4714 69.8855H10.5885C8.84116 69.8855 7.16533 69.1913 5.92974 67.9557C4.69415 66.7201 4 65.0443 4 63.2969V40.237C4 38.4896 4.69415 36.8138 5.92974 35.5782C7.16533 34.3426 8.84116 33.6485 10.5885 33.6485H20.4714M43.5313 27.0599V13.8828C43.5313 11.2617 42.4901 8.748 40.6367 6.89461C38.7833 5.04122 36.2696 4 33.6485 4L20.4714 33.6485V69.8855H57.6308C59.2197 69.9034 60.7616 69.3465 61.9723 68.3174C63.1831 67.2883 63.9811 65.8563 64.2193 64.2852L68.7654 34.6367C68.9088 33.6925 68.8451 32.7283 68.5788 31.8111C68.3125 30.8939 67.85 30.0455 67.2232 29.3248C66.5965 28.6041 65.8206 28.0282 64.9492 27.6371C64.0779 27.2461 63.1319 27.0491 62.1769 27.0599H43.5313Z",
    stroke: "white",
    strokeWidth: 6.58855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.9b4360119ab8c19c76369f0a0eee9f6a.svg";
export { ForwardRef as ReactComponent };